import React, { useEffect, useRef, useState } from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
// import ProductOverView from "../product/ProductOverView";
// import AxiosInstance from "../../../utils/AxiosInstance";
// import { useNetwork } from "../../../context/NetworkContext";
// import handleError from "../../../constants/handleError";
// import { useShowAlert } from "../../../context/AlertContext";
// import Messages from "../../../constants/Messages";

const ViewProductReport = ({ isData, isLoading, isActive, onSaleView }) => {
  const { isUser, updateSettings } = useAuth();
  const reportData = isData?.reportData || [];
  const saleNoData = reportData.filter((row) => row.saleno);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { storeSettings } = usePermission();
  // const [viewData, setViewData] = useState([]);
  // const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  // const [isViewModalOpen, setViewModalOpen] = useState(false);
  // const [selectTermalOption, setSelectTermalOption] = useState("");
  // const [selectedOption, setSelectedOption] = useState("");
  // const [reportModelOpen, setReportModelOpen] = useState(false);
  // const hasFetched = useRef(false);
  // const [isProductData, setProductData] = useState([]);
  // const [isBtnLoading, setBtnLoading] = useState(false);
  // const [isEditModalOpen, setEditModalOpen] = useState(false);
  // const { checkNetwork } = useNetwork();
  // const [isEditData, setEditData] = useState(null);
  // const [brandSuggest,setBrandSuggest]=useState([]);
  // const [productViewOpen, setProductViewOpen] = useState(false);
  // const [noteSuggest, setNoteSuggest] = useState([]);
  // const showAlert = useShowAlert();
  // const [currentPage, setCurrentPage] = useState(0);
  // const [totalPages, setTotalPages] = useState(0);
  // const [productData, setPrductData] = useState([]);
  // const [productStockData, setPrductStockData] = useState([]);
  // const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const hasSaleNoData = saleNoData.length > 0;
  const sections = [
    { key: "products", label: "Product" },
    { key: "services", label: "Service" },
    { key: "recharges", label: "Recharge" },
  ];

  const modeMap = {
    products: "PRODUCT",
    services: "SERVICE",
    recharges: "RECHARGE",
  };

  const sectionData = sections.map(({ key, label }) => {
    const items = reportData.filter((row) => row.imode === modeMap[key]);
    return { key, label, items };
  });

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      const results = response.data.results;
      return results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  // const handleSaleView = async (item) => {
  //   // if (item.trackmode === "SALE") {
  //   const data = await handleSaleItems(item.saleId);
  //   if (data) {
  //     setViewData(data);
  //     setViewModalOpen(true);
  //     setViewTempModalOpen(true);
  //   }
  //   // }
  // };

  // const handleSetTemplate = async (
  //   templateId,
  //   selectTermalOption,
  //   selectHalfA4Option,
  //   templateTheme,
  //   show = true,
  // ) => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance.patch(
  //       `module/storesettings/template`,
  //       {
  //         templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
  //         templateTheme,
  //       },
  //     );
  //     const results = response.data?.results?.invoiceSettings?.template;
  //     const id = results.templateId;
  //     const words = id.split("AND");
  //     setSelectedOption(words[0]);
  //     setSelectTermalOption(words[1]);
  //     setViewTempModalOpen(false);
  //     updateSettings({
  //       storeSettings: {
  //         invoiceSettings: {
  //           template: {
  //             templateId: results?.templateId,
  //             templateTheme: results?.templateTheme,
  //           },
  //           signature: results?.signature,
  //           termsAndConditions: results?.termsAndConditions,
  //         },
  //       },
  //     });
  //     {
  //       show && showAlert("success", "Template Selected...");
  //     }
  //   } catch (error) {
  //     handleError(error, showAlert);
  //   }
  // };

  // const handleSaleClose = () => {
  //   setViewModalOpen(false);
  //   setViewData(null);
  //   // navigate(location.pathname, { replace: true, state: {} });
  // };

  // const closeSaleReportView = () => {
  //   setReportModelOpen(false);
  // };

  // const handleOpenProductView = async (product) => {
  //   console.log(product)
  //   await handleProductDetails(product);
  //   await handleStockDetails(product);
  //   setProductViewOpen(true);
  // };

  // const handleSuggestNote = async () => {
  //   try {
  //     if (!checkNetwork()) return;
  //     const response = await AxiosInstance.get(
  //       `module/product/note/suggestion?language=en`,
  //     );

  //     setNoteSuggest(response.data.results || []);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  // const handleProductDetails = async (product) => {
  //     try {
  //       if (!checkNetwork()) return;
  //       const response = await AxiosInstance.get(
  //         `module/product/view-product/${product._id}`,
  //       );
  //       const products = response.data?.results;
  //       setPrductData(products);

  //     } catch (error) {
  //       // handleError(error, showAlert);
  //     }
  //   };
  //   const handleStockDetails = async (product) => {
  //     try {
  //       if (!checkNetwork()) return;
  //       const data = { productid: product._id };
  //       const response = await AxiosInstance.get(
  //         `module/stock/primary-store/${product._id}`,
  //       );
  //       const products = response.data?.results;
  //       setPrductStockData(products);

  //     } catch (error) {
  //       // handleError(error, showAlert);
  //     }
  //   };
  //   const handleCloseProductView = () => {
  //     setProductViewOpen(false);
  //   };

  //   const closeEditModal = () => {
  //     setEditData(null);
  //     setEditModalOpen(false);
  //   };

  //   const handleUpdte = async (updatedData, imageFile, trigger = true) => {
  //     const original = isEditData ||productData;

  //     const formData = new FormData();
  //     let isDataChanged = false;

  //     const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
  //       if (newVal !== oldVal) {
  //         formData.append(key, transform(newVal));
  //         isDataChanged = true;
  //       }
  //     };

  //       const isPriceGroupChanged =
  //       updatedData?.mrp !== original?.mrp ||
  //       updatedData?.saleprice !== original?.saleprice ||
  //       updatedData?.baseprice !== original?.baseprice ||
  //       updatedData?.taxpercentage !== original?.taxpercentage ||
  //       updatedData?.isLock !== original?.isLock;

  //     if (isPriceGroupChanged) {
  //       formData.append(
  //         "mrp",
  //         CurrencyConverter.toSubunit(updatedData?.mrp, "INR")
  //       );
  //       formData.append(
  //         "saleprice",
  //         CurrencyConverter.toSubunit(updatedData?.saleprice, "INR")
  //       );
  //       formData.append(
  //         "baseprice",
  //         CurrencyConverter.toSubunit(updatedData?.baseprice, "INR")
  //       );
  //       formData.append("taxpercentage", updatedData?.taxpercentage);
  //       formData.append("isLock", updatedData?.isLock);

  //       isDataChanged = true;
  //     }

  //     appendIfChanged("code", updatedData?.code, original?.code);
  //     appendIfChanged("hsnsac", updatedData?.hsnsac ?? "", original?.hsnsac ?? "");
  //     appendIfChanged("title", updatedData?.title, original?.title);
  //     // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
  //     // appendIfChanged("isLock", updatedData.isLock, original.isLock);
  //     appendIfChanged("note", updatedData?.note, original?.note);
  //     appendIfChanged("searchTag", updatedData?.searchTag ?? "", original?.searchTag ?? "");
  //     appendIfChanged("brandId",updatedData?.brandData?.title??"",original?.brandId??"");
  //     // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //     // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //     // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //     appendIfChanged("landingcost",updatedData?.landingcost || 0,original?.landingcost || 0,(v) => CurrencyConverter.toSubunit(v, "INR"));

  //     const newUnit = updatedData?.unitConfig;
  //     const oldUnit = original?.unitConfig;

  //     if (
  //       !updatedData?.unitLocked &&
  //       JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
  //     ) {
  //       formData.append("unitConfig", JSON.stringify(newUnit));
  //       isDataChanged = true;
  //     }
  //     if (imageFile instanceof File) {
  //       formData.append("primaryImage", imageFile);
  //       isDataChanged = true;
  //     }

  //     if (!isDataChanged) {
  //       showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //       if (trigger) closeEditModal();
  //       return true;
  //     }
  //     setBtnLoading(true);
  //     try {
  //       if (!checkNetwork()) return;

  //       const response = await AxiosInstance.patch(
  //         `module/product/update-product/${updatedData._id}`,
  //         formData,
  //         { headers: { "Content-Type": "multipart/form-data" } }
  //       );

  //       showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);

  //       setProductData((prev) =>
  //         prev.map((p) =>
  //           p._id === response.data.results?._id
  //             ? response.data.results
  //             : p
  //         )
  //       );

  //       if (trigger) closeEditModal();
  //       return true;
  //     } catch (error) {
  //       handleError(error, showAlert);
  //       return false;
  //     } finally {
  //       setBtnLoading(false);
  //     }
  //   };

  //   const handleBrandSuggest=async()=>{
  //     try{
  //       if (!checkNetwork()) return;
  //       const response = await AxiosInstance.get(`module/product/brand/suggestion`);
  //       const result=response?.data?.results;
  //       setBrandSuggest(result)
  //     }catch(error){
  //       handleError(error, showAlert);
  //       return false;
  //     }
  //   }

  // const hadlEditStockData = (updatedData, stockData, quantity) => {
  //   const totalStock = stockData.reduce(
  //     (total, item) => total + (item.stockLeft || 0),
  //     0,
  //   );
  //   setProductData((prevProductData) =>
  //     prevProductData.map((product) =>
  //       product._id === updatedData?.productid
  //         ? {
  //             ...product,
  //             totalStockLeft: totalStock + quantity,
  //           }
  //         : product,
  //     ),
  //   );
  // };

  // const hadlTrashStockData = (updatedData, stockData, quantity) => {
  //   const totalStock = stockData.reduce(
  //     (total, item) => total + (item.stockLeft || 0),
  //     0,
  //   );
  //   setProductData((prevProductData) =>
  //     prevProductData.map((product) =>
  //       product._id === updatedData?.productid
  //         ? {
  //             ...product,
  //             totalStockLeft: totalStock - quantity,
  //           }
  //         : product,
  //     ),
  //   );
  // };

  // useEffect(() => {
  //   if (hasFetched.current) return;
  //   hasFetched.current = true;
  //   handleSuggestNote();
  //   handleBrandSuggest();
  // }, []);

  // useEffect(() => {
  //   const id = storeSettings?.invoiceSettings?.template?.templateId || "";
  //   const words = id ? id?.split("AND") : [];
  //   setSelectedOption(words[0]);
  //   setSelectTermalOption(words[1]);
  // }, []);

  const allEmpty = sectionData.every((section) => section.items.length === 0);
  return (
    <div>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">PRODUCT REPORT</td>
            </tr>
          </tbody>
        </table>
        <div className="d-flex rtable">
          <div className="w-100 text-center">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                  <td>From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                  <td>To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {!hasSaleNoData ? (
          <table className="table table-sm table-bordered mb-3 rtable">
            <thead>
              <tr>
                <th className="text-center">S No</th>
                <th className="w-45 text-center">Title</th>
                {/* <th className="text-center">Unit</th> */}
                <th className="text-center">Tax (%)</th>
                <th className="text-center">Quantity</th>
                <th className="text-center">Price</th>
                <th className="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              {allEmpty ? (
                <tr>
                  <td colSpan={11} className="text-center text-muted">
                    No Data Available
                  </td>
                </tr>
              ) : (
                sectionData.map(({ key, label, items }) =>
                  items.length > 0
                    ? [
                        <tr key={`${key}-heading`}>
                          <td
                            colSpan={11}
                            className="fw-600 bg-light text-center"
                          >
                            {label}
                          </td>
                        </tr>,
                        ...items.map((item, idx) => (
                          <tr
                            key={`${key}-${idx}`}
                            // onClick={() => {
                            //   if (label === "Product") {
                            //     handleOpenProductView(item);
                            //   }
                            // }}
                            // className={
                            //   label === "Product"
                            //     ? "cursor-pointer"
                            //     : ""
                            // }
                          >
                            <td className="text-center">{idx + 1}</td>
                            <td className="w-45 text-center">
                              {key === "recharges"
                                ? `Recharge - ${item?.operator || ""}`
                                : item?.title}
                            </td>
                            {/* <td className="text-center">
                            <span className="badge btn-unit">
                                  {item?.unitConfig?.primaryUnitCode}
                                </span>
                            </td> */}
                            <td className="text-center">
                              {item.taxpercentage}
                            </td>
                            <td className="text-center">
                              {item.quantity}{" "}
                              {item?.unitConfig?.primaryUnitCode}
                            </td>
                            <td className="text-center">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.soldprice || 0,
                                "INR",
                              )}
                            </td>
                            <td className="text-center fw-600">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.lineGrandTotal || 0,
                                "INR",
                              )}
                            </td>
                          </tr>
                        )),
                        <tr
                          key={`${key}-total`}
                          className="fw-600"
                          style={{ backgroundColor: "#eaf6ea" }}
                        >
                          <td colSpan={5} className="text-end">
                            Total {label} Amount
                          </td>
                          <td className="text-center">
                            ₹
                            {CurrencyConverter.toCurrency(
                              items.reduce(
                                (sum, i) => sum + (i.lineGrandTotal || 0),
                                0,
                              ),
                              "INR",
                            )}
                          </td>
                        </tr>,
                      ]
                    : null,
                )
              )}
            </tbody>
          </table>
        ) : (
          <table className="table table-sm table-bordered mb-3 rtable">
            <thead>
              <tr>
                <th className="text-center">S No</th>
                <th className="text-center">Sale No</th>
                <th className="text-center">SaleMode</th>
                <th className="text-center">Sale Date</th>
                <th className="text-center">MRP</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Sale Price</th>
                <th className="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              {saleNoData.map((item, idx) => (
                <tr
                  key={idx}
                  className="position-relative  cursor-poInter hover-row"
                  onClick={() => onSaleView(item)}
                >
                  <td className="text-center">{idx + 1}</td>
                  <td className="text-center">{item.saleno}</td>
                  <td className="text-center">{item.salemode}</td>
                  <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item.saledate,
                          isUser?.timezone,
                        ),
                      ).date
                    }
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item.lineTotalMrp || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center"> {item.quantity} </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item.lineTotalSoldPrice || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center fw-600">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item.lineGrandTotal || 0,
                      "INR",
                    )}
                  </td>
                </tr>
              ))}

              {/* SaleNo Total */}
              <tr className="fw-600" style={{ backgroundColor: "#eaf6ea" }}>
                <td colSpan={7} className="text-end">
                  Total Amount
                </td>
                <td className="text-center">
                  ₹
                  {CurrencyConverter.toCurrency(
                    saleNoData.reduce(
                      (sum, i) => sum + (i.lineGrandTotal || 0),
                      0,
                    ),
                    "INR",
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        )}

        {/* Tax Overview (same for both) */}
        <div className="d-flex rtable">
          <div className="w-30">
            {isData?.taxSummary && isData?.taxSummary?.length > 0 && (
              <table className="table table-sm table-bordered mb-0 rtable text-center">
                <thead>
                  <tr>
                    <td colSpan="5">Tax Overview</td>
                  </tr>
                  <tr>
                    <td className="w-25">Tax %</td>
                    <td>Tax Amount</td>
                    <td>SGST Amount</td>
                    <td>CGST Amount</td>
                    <td>IGST Amount</td>
                  </tr>
                </thead>
                <tbody>
                  {isData?.taxSummary?.slice(0, -1).map((item, index) => (
                    <tr key={index}>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `${item.taxpercentage}%`
                        )}
                      </td>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            Number(item?.totalTaxAmount || 0),
                            "INR",
                          )}`
                        )}
                      </td>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            Number(item?.totalSgstAmount || 0),
                            "INR",
                          )}`
                        )}
                      </td>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            Number(item?.totalCgstAmount || 0),
                            "INR",
                          )}`
                        )}
                      </td>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            Number(item?.totalIgstAmount || 0),
                            "INR",
                          )}`
                        )}
                      </td>
                    </tr>
                  ))}
                  {!isLoading && isData?.taxSummary?.length > 0 && (
                    <tr className="font-bold border-t bg-gray-100">
                      <td>Total</td>
                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.taxSummary[isData.taxSummary.length - 1]
                            ?.taxTotal || 0,
                          "INR",
                        )}
                      </td>
                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.taxSummary[isData.taxSummary.length - 1]
                            ?.sgstTotal || 0,
                          "INR",
                        )}
                      </td>
                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.taxSummary[isData.taxSummary.length - 1]
                            ?.cgstTotal || 0,
                          "INR",
                        )}
                      </td>
                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.taxSummary[isData.taxSummary.length - 1]
                            ?.igstTotal || 0,
                          "INR",
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {/* {productViewOpen && (
          <ProductOverView
            onClose={handleCloseProductView}
            onData={productData}
            onStockData={productStockData}
            onUpdate={handleUpdte}
            noteSuggests={noteSuggest}
            isBtnLoading={isBtnLoading}
            setProductData={setProductData}
            onStockEditData={hadlEditStockData}
            OnStockTrashData={hadlTrashStockData}
            // handleDeteleDataUpdate={handleDeteleDataUpdate}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )} */}
      {/* {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={viewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}

      {(selectedOption === "INVPRO" || selectedOption === "INVOICEONE") &&
        isViewModalOpen && (
          <ProfessionalGSTInvoice
            isData={viewData}
            isActive={isActive}
            selectedOption={selectedOption}
            onClose={handleSaleClose}
            onDataUpdate={async () => {
              const data = await handleSaleItems(viewData?._id);
              if (data) setViewData(data);
            }}
            onDataChange={true}
          />
        )}
      {(selectedOption === "INVESS" || selectedOption === "INVOICETWO") &&
        isViewModalOpen && (
          <EssentialInvoice
            isData={viewData}
            isActive={isActive}
            selectedOption={selectedOption}
            onClose={handleSaleClose}
            onDataUpdate={async () => {
              const data = await handleSaleItems(viewData?._id);
              if (data) setViewData(data);
            }}
            onDataChange={true}
          />
        )}
      {(selectedOption === "INVSTR" || selectedOption === "INVOICEFOUR") &&
        isViewModalOpen && (
          <StructuredInvoice
            isData={viewData}
            isActive={isActive}
            selectedOption={selectedOption}
            onClose={handleSaleClose}
            onDataUpdate={async () => {
              const data = await handleSaleItems(viewData?._id);
              if (data) setViewData(data);
            }}
            onDataChange={true}
          />
        )}
      {(selectedOption === "INVCOM" || selectedOption === "INVOICEFIVE") &&
        isViewModalOpen && (
          <CommercialInvoice
            isData={viewData}
            isActive={isActive}
            selectedOption={selectedOption}
            onClose={handleSaleClose}
            onDataUpdate={async () => {
              const data = await handleSaleItems(viewData?._id);
              if (data) setViewData(data);
            }}
            onDataChange={true}
          />
        )}
      {(selectedOption === "INVSEV" || selectedOption === "INVOICESIX") &&
        isViewModalOpen && (
          <ServiceInvoice
            isData={viewData}
            isActive={isActive}
            selectedOption={selectedOption}
            onClose={handleSaleClose}
            onDataUpdate={async () => {
              const data = await handleSaleItems(viewData?._id);
              if (data) setViewData(data);
            }}
            onDataChange={true}
          />
        )}
      {selectedOption === "INVLEX" && isViewModalOpen && (
        <LegendExecutiveInvoice
          isData={viewData}
          isActive={isActive}
          selectedOption={selectedOption}
          onClose={handleSaleClose}
          onDataUpdate={async () => {
            const data = await handleSaleItems(viewData?._id);
            if (data) setViewData(data);
          }}
          onDataChange={true}
        />
      )}
      {selectedOption === "INVPRM" && isViewModalOpen && (
        <PrimeInvoice
          isData={viewData}
          isActive={isActive}
          selectedOption={selectedOption}
          onClose={handleSaleClose}
          onDataUpdate={async () => {
            const data = await handleSaleItems(viewData?._id);
            if (data) setViewData(data);
          }}
          onDataChange={true}
        />
      )}
      {reportModelOpen && (
        <ReportView onClose={closeSaleReportView} viewData={viewData} />
      )} */}
    </div>
  );
};

export default ViewProductReport;
